import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography, IconButton, Stack, Paper } from "@mui/material"
import { Help, KeyboardArrowRight } from "@mui/icons-material"
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import FloatingButton from "./components/FloatingButton";
import FloatingBox from "./components/FloatingBox";
import { Button } from "@gisce/oficina-virtual-components";
import { useSettingsContext } from "../Settings/hooks/useSettingsContext";

const HelpDialog = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  const [folded, setFolded] = useState(true);

  const email = Settings?.organization?.email ?? "";
  const phoneLink = (Settings?.organization?.phone_crm ?? "").replace(
    " ", "");
  const phone = Settings?.organization?.phone_crm ?? "";
  
  let contactUrl = t('common:url.unsigned_contact');
  if (isAuthenticated) {
    contactUrl = t('common:url.contact');
  }

  const handleFold = () => {
    setFolded(!folded);
  }

  const handleContact = () => {
    const url = Settings?.helpDialog?.customURL ?? contactUrl;
    ((url.search('www') !== -1) || url.search('http') !== -1) ? 
      window.location.replace(url) : navigate(url);
  };

  return (
    <>
      {folded && 
        <FloatingButton 
          onClick={handleFold}
          variant="contained"
          color="primary"
          sx={{
            bottom: "240px",
            borderRadius: "32px 0 0 32px",
            minWidth: 0,
            padding: 0,
            right: 0,
          }}
        >
          <Help sx={{fontSize: 50}}/>
        </FloatingButton>
      }
      {!folded && (
        <FloatingBox
          sx={{
            bottom: "60px",
            width: "350px",
            right: 0,
            padding: "3rem 0"
          }}
        >
          <Paper elevation={4} sx={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
          }}>

          <Button 
              onClick={handleFold}
              variant="contained"
              color="primary"
              disableElevation={true}
              sx={{
                position: "absolute",
                float: "left",
                left: 0,
                top: "64px",
                borderRadius: "0 6px 6px 0",
                minWidth: 0,
                height: "32px",
                width: "32px",
                paddingLeft: 0,
                paddingRight: 0,
              }}
            >
              <KeyboardArrowRight />
            </Button>

            <Stack 
              direction="column" 
              spacing={2}
              alignItems="stretch"
              justifyContent="center"
              pt={4}
              pb={2}
            >

              <Typography variant="h5" textAlign="center">
                {t('common:text.help_dialog_title')}
              </Typography>

              {Settings?.helpDialog?.onlyButton ?
                <Typography textAlign="center">
                  {t('common:text.help_dialog_custom_text')}
                </Typography>
              :
                <>
                  <Stack direction="column" alignItems="flex-start" pl={6}>
                    <Typography>
                      {t('common:text.help_dialog_send_mail')}
                    </Typography>
                    <Button 
                      size="small" 
                      href={`mailto:${email}`}
                      color="primary"
                      variant="text"
                    >
                      {email}
                    </Button>
                  </Stack>

                  <Stack direction="column" alignItems="flex-start" pl={6}>
                    <Typography>
                      {t('common:text.help_dialog_call')}
                    </Typography>
                    <Button 
                      size="small" 
                      href={`tel:${phoneLink}`} 
                      color="primary"
                      variant="text"
                    >
                      {phone}
                    </Button>
                  </Stack>
                </>              
              }

              {((Settings?.features?.contact ?? false) ||
                (Settings?.features?.unsignedContact ?? false) ||
                (Settings?.helpDialog?.customURL ?? false)) && 
                <Stack direction="column" alignItems="center">
                  <Button
                    variant={"contained"}
                    color={"primary"}
                    onClick={handleContact}
                  >
                    {t('common:text.help_dialog_contact_button')}
                  </Button>
                </Stack>
              }

            </Stack>

          </Paper>
        </FloatingBox>
      )}
    </>
  );
};

export default HelpDialog;
